import { CreateUnslotDto, UnslotSpecFormDataDto, UnslotSpecHistoryDto, UnslotSpecStatusDto, VariableCategoryDto } from "app/ApiClient";
import { LoadingState } from "types";

export interface VariableCategoriesState {
  loadingState: LoadingState,
  categories?: VariableCategoryDto[] | undefined,
  error?: string,
}

export interface SlottedVariableState {
  label:string,
  fieldText:string,
  displayLabelText:string,
}

export interface UnslotVariablesForm {
  unslotSpecName:string,
  numOfSlotVariables:number,
  slotVariables:string[],
  brands:VariableCategoryDto[],
  variablesToUnslot:SlottedVariableState[],
}

export const initialUnslotVariablesForm: UnslotVariablesForm = {
  unslotSpecName:"",
  numOfSlotVariables: 1,
  slotVariables:[],
  brands:[],
  variablesToUnslot:[],
};

export interface UnslotVariablesState {
  createUnslotSpecState: LoadingState;
  UnslotSpec: CreateUnslotDto | null;

  unslotSpecHistoriesState: LoadingState;
  UnslotSpecHistories: UnslotSpecHistoryDto[] | null;

  unslotSpecStatusState:LoadingState;
  unslotSpecStatus: UnslotSpecStatusDto | null;

  unslotPollingState:LoadingState;

  variablesCategories: Record<number, VariableCategoriesState>;
  brands:VariableCategoryDto[];
  validBrands?:boolean;
  isUnslotVariablesDialogOpended: boolean;
  isMinimiseDialog: boolean;

  isUnslotVariablesRecordDialogOpended:boolean;
  selectedUnslotSpecName?:string;
  unslotSpecsFormDataState:LoadingState;
  unslotSpecsFormData?:UnslotSpecFormDataDto;
}

export const initialUnslotVariablesState: UnslotVariablesState = {
  createUnslotSpecState: LoadingState.idle,
  UnslotSpec: null,

  unslotSpecHistoriesState: LoadingState.idle,
  UnslotSpecHistories: null,

  unslotSpecStatusState:LoadingState.idle,
  unslotSpecStatus: null,
  
  unslotPollingState: LoadingState.idle,

  variablesCategories:{},
  brands:[],
  isUnslotVariablesDialogOpended: false,
  isMinimiseDialog: false,

  isUnslotVariablesRecordDialogOpended:false,
  unslotSpecsFormDataState: LoadingState.idle,
};
